


import { useEffect } from "react";
import { initGA } from "./analytics";
import AnalyticsTracker from "./AnalyticsTracker";

import AOS from "aos";
import "aos/dist/aos.css";

import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import './assets/css/Global.css';
import './assets/css/Responsive.css';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import 'primeicons/primeicons.css';
import GlobalScrollManager from "./pages/GlobalScrollManager";

import PublicOnlyRoute from "./interfaces/PublicOnlyRoute";
import ProtectedRoute from "./interfaces/PrivateRoute";
import { AuthProvider } from "./context/AuthContext";
import GifLoder from "./interfaces/GifLoder";
import { ToastContainer } from "react-toastify";
import { Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Bulkproductdetails from "./pages/Bulkproductdetails";
import { Navigate } from "react-router-dom";

/* ===================== Pages ===================== */
// Public Pages
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Account from "./pages/Account";
import Cart from "./pages/Cart";
import Packages from "./pages/Packages";
import Productdetails from "./pages/Productdetails";
import Wishlist from "./pages/Wishlist";
import Checkout from "./pages/Checkout";

// Policy Pages
import TermsAndCondition from "./pages/Policy/TermsAndCondition";
import Privacypolicy from "./pages/Policy/Privacypolicy";
import Cookiepolicy from "./pages/Policy/Cookiepolicy";
import Refundpolicy from "./pages/Policy/Refundpolicy";
import Coinpolicy from "./pages/Policy/Coinpolicy";

// Auth Pages
import Login from "./pages/Login";
import Register from "./pages/Register";
import Forgot from "./pages/Forgot";
import Otp from "./pages/Otp";

// User Admin
import Dashboard from "./pages/Useradmin/Dashboard";

// Admin Pages
import Customerdetails from "./pages/adminpage/Customerdetails";
import PromoPopup from "./components/PromoPopup";

//Thank you page
import Thankyou from "./pages/Thankyou";
import Reset_password from "./pages/Reset_password";
import PlanChangePage from "./pages/PlanChangePage";
import MainHome from "./pages/MainHome";
import Coinbuy from "./pages/Coinbuy";
import Profile from "./pages/Useradmin/Profile";
import CreditTransactions from "./pages/Useradmin/CreditTransactions";
import Subscriptions from "./pages/Useradmin/Subscriptions";
import Favorites from "./pages/Useradmin/Favorites";
import Billing from "./pages/Useradmin/Billing";
import Raiseticket from "./pages/Useradmin/Raiseticket";
import Download from "./pages/Useradmin/Download";
import CookieConsentPopup from "./components/CookieConsentPopup";
import LowCoinFloatingButton from "./components/LowCoinFloatingButton";
import CategoryPreferencePopup from "./components/CategoryPreferencePopup";
import Preference from "./pages/Useradmin/Preference";
import CommingSoon from "./pages/CommingSoon";
import Waitlist from "./pages/Waitlist";
import LaunchIntro from "./pages/LaunchIntro";
import RedeemOffers from "./pages/Useradmin/RedeemOffers";
import CustomerSpinWheel from "./pages/Useradmin/CustomerSpinWheel";

import NewmainHome from "./pages/NewmainHome";
import NewafterloginHome from "./pages/NewafterloginHome";

/* ---------- Layout Component ---------- */
function Layout({ children }) {
  const location = useLocation();

  const hideLayout =
    ["/login", "/register", "/forgot", "/otp", "/coming-soon", "/terms-and-condition", "/privacy-policy", "/cookie-policy", "/coin-policy", "/waitlist", "/LaunchIntro"].includes(location.pathname) ||
    location.pathname.startsWith("/resetpassword/");

  return (
    <>
      {!hideLayout && <Header />}

      <main className={!hideLayout ? "page-content" : ""}>
        {children}
      </main>

      {!hideLayout && <Footer />}

      {!hideLayout && <LowCoinFloatingButton />}
    </>
  );
}


function MainHomeLaunch() {
  return (
    <LaunchIntro>
      <MainHome />
    </LaunchIntro>
  );
}

/* ---------- App Component ---------- */
function App() {
  // useEffect(() => {
  //   initGA(); // 🔥 initialize GA ONCE
  // }, []);

  /*-----------AOS------------*/

  useEffect(() => {
    AOS.init({
      duration: 900,
      easing: "ease-out-cubic",
      once: true,
      offset: 100
    });
  }, []);

  return (
    <AuthProvider>
      <Router>
        <AnalyticsTracker />
        <GlobalScrollManager />
        {/* ✅ React Toastify (GLOBAL) */}
        <ToastContainer
          position="bottom-right"
          autoClose={3500}
          hideProgressBar={false}
          newestOnTop
          closeOnClick={false}
          rtl
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
          transition={Flip}
        />
        <CookieConsentPopup />
        <CategoryPreferencePopup />
        <Layout>
          <PromoPopup />
          <Routes>
            <Route path="/" element={<PublicOnlyRoute element={NewmainHome} />} />
            {/* <Route path="/Mainhome" element={<PublicOnlyRoute element={MainHome} />} />
            <Route path="/" element={<PublicOnlyRoute element={MainHome} />} /> */}
            <Route path="/coming-soon" element={<CommingSoon />} />
            <Route path="/home" element={<ProtectedRoute element={NewafterloginHome} />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/account" element={<Account />} />
            <Route path="/packages" element={<Packages />} />
            <Route path="/coinbuy" element={<Coinbuy />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/product/:productId/:slug" element={<Productdetails />} />
            <Route path="/product/:productId" element={<Productdetails />} />

            <Route
              path="/product_details/:productId"
              element={<Productdetails />}
            />
            <Route path="/wishlist" element={<Wishlist />} />
            <Route path="/checkout" element={<ProtectedRoute element={Checkout} />} />
            <Route path="/terms-and-condition" element={<TermsAndCondition />} />
            <Route path="/privacy-policy" element={<Privacypolicy />} />
            <Route path="/cookie-policy" element={<Cookiepolicy />} />
            <Route path="/refund-policy" element={<Refundpolicy />} />
            <Route path="/coin-policy" element={<Coinpolicy />} />
            <Route path="/planupdate" element={<PlanChangePage />} />
            {/* Bundles are now listed in the shop alongside products */}
            <Route path="/bulkproductlist" element={<Navigate to="/shop" replace />} />
            <Route path="/bundleproductdetails/:bundleId" element={<Bulkproductdetails />} />

            {/* Auth Routes (NO Header/Footer) */}
            <Route path="/login" element={<PublicOnlyRoute element={Login} />} />
            <Route path="/register" element={<PublicOnlyRoute element={Register} />} />
            <Route path="/forgot" element={<PublicOnlyRoute element={Forgot} />} />
            <Route path="/resetpassword/:token" element={<PublicOnlyRoute element={Reset_password} />} />
            <Route path="/otp" element={<PublicOnlyRoute element={Otp} />} />

            {/* User Admin */}
            <Route
              path="/dashboard"
              element={<ProtectedRoute element={Dashboard} />}
            >
              <Route index element={<Navigate to="profile" replace />} />

              <Route path="profile" element={<Profile />} />
              <Route path="credit-transactions" element={<CreditTransactions />} />
              <Route path="subscriptions" element={<Subscriptions />} />
              <Route path="favorites" element={<Favorites />} />
              <Route path="billing" element={<Billing />} />
              <Route path="raise-ticket" element={<Raiseticket />} />
              <Route path="downloads" element={<Download />} />
              <Route path="preference" element={<Preference />} />
              <Route path="offers" element={<RedeemOffers />} />
              <Route
                path="spin-wheel"
                element={<CustomerSpinWheel />}
              />
            </Route>

            {/* admin pages */}
            <Route path="/customersdetails" element={<Customerdetails />} />

            {/* Thank you page */}

            <Route path="/thankyou" element={<ProtectedRoute element={Thankyou} />} />
            <Route path="/waitlist" element={<Waitlist />} />


            <Route path="/newmain-home" element={<NewmainHome />} />
            <Route path="/newafterlogin-home" element={<NewafterloginHome />} />

          </Routes>
        </Layout>
      </Router>
    </AuthProvider>
  );
}

export default App;

